import { Component, HostListener, computed, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { GuidedTourService } from '../../services/guided-tour/guided-tour.service';
import { getTourPromptContent } from '../../utils/tour-prompt-content.util';

@Component({
  selector: 'app-tour-prompt',
  imports: [ButtonModule],
  templateUrl: './tour-prompt.html',
  styleUrl: './tour-prompt.css',
})
export class TourPrompt {
  readonly tourService = inject(GuidedTourService);

  readonly content = computed(() => {
    const audience = this.tourService.promptAudience();
    return audience ? getTourPromptContent(audience) : null;
  });

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.tourService.promptVisible()) {
      this.tourService.dismissPrompt();
    }
  }

  accept(): void {
    this.tourService.acceptPrompt();
  }

  dismiss(): void {
    this.tourService.dismissPrompt();
  }
}
